import { Section } from '../../components/Section'
import { Customers } from '../../components/Customers'

export function Clientes() {
 return (
  <Section id="clientes" title="Clientes" className="py-20">
   <div className="container">
    <Customers />
   </div>
  </Section>
 )
}
